import { gql } from '@apollo/client';

export const SAVE_DRAFT = gql`
  mutation addDraft($draft: DraftInput!) {
    addDraft(draft: $draft) {
      success
      message
    }
  }
`;

export const DELETE_DRAFT = gql`
  mutation deleteDraft($id: String!) {
    deleteDraft(id: $id) {
      success
      message
    }
  }
`;

export const GET_DRAFTS = gql`
  query drafts(
    $offset: Int
    $limit: Int
    $isScheduled: Boolean
    $isPublished: Boolean
  ) {
    drafts(
      offset: $offset
      limit: $limit
      isScheduled: $isScheduled
      isPublished: $isPublished
    ) {
      id
      savedate
      title
      snapshot
      scheduledDate
      publishedDate
      isScheduleFailed
    }
  }
`;

export const GET_DRAFT_BY_ID = gql`
  query draft($id: String!) {
    draft(id: $id) {
      title
      body
      json
      isCodeEditor
    }
  }
`;

export const CHECK_IF_DRAFT_EXISTS = gql`
  query draft($id: String!) {
    draft(id: $id) {
      title
    }
  }
`;
